import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { constants } from '@clubmed/utils';
import { changeDepartureCity } from 'Store/faceting/facetingSearch.action';
import { hasDepartureCityAvailable } from 'Utils/faceting/facetingUtils';
const { NO_TRANSPORT_VALUE } = constants;
type Props = {
  departureCitiesOptions: DepartureCities;
  departureCity: string;
  initialTransport?: string | null | undefined;
  onChange?: (arg0: string) => void;
  withValidDepartureCity?: boolean;
};
export function useSyncDepartureCity({
  departureCitiesOptions,
  departureCity,
  initialTransport,
  onChange,
  withValidDepartureCity,
}: Props) {
  const dispatch = useDispatch();
  const isDepartureCityAvailable = hasDepartureCityAvailable(departureCitiesOptions, departureCity);

  const _departureCity =
    withValidDepartureCity && departureCity && !isDepartureCityAvailable ? null : departureCity;

  const [inputDepartureCity, setInputDepartureCity] = useState<string>(
    _departureCity || initialTransport || NO_TRANSPORT_VALUE,
  );
  // Store update effect
  useEffect(() => {
    let newDepartureCity = departureCity;

    if (withValidDepartureCity && newDepartureCity && !isDepartureCityAvailable) {
      newDepartureCity = initialTransport || NO_TRANSPORT_VALUE;
      dispatch(changeDepartureCity(newDepartureCity));
    }

    // 1. Sync local state with store updates
    if (inputDepartureCity !== newDepartureCity) {
      setInputDepartureCity(newDepartureCity);
    }

    // 2. Sync criteria validation with store updates
    if (onChange) {
      onChange(newDepartureCity);
    }
  }, [departureCity]);
  return {
    inputDepartureCity,
    setInputDepartureCity,
  };
}
